module.exports = __webpack_public_path__ + "img/new-step10.60fe2f5e.jpg";